var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.viewer
      ? _c("div", { staticClass: "card border-0 shadow-sm" }, [
          _c(
            "div",
            {
              staticClass:
                "card-header bg-white d-flex align-items-center justify-content-between gap-2",
            },
            [
              _c("span", { staticClass: "fw-semibold" }, [
                _vm._v(_vm._s(_vm.viewer.title)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex gap-2" }, [
                _vm.viewer.type === "html" && !_vm.viewer.loading
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-danger",
                        attrs: { disabled: _vm.mengunduh_pdf },
                        on: { click: _vm.unduhPdf },
                      },
                      [
                        _c("i", {
                          staticClass: "fa",
                          class: _vm.mengunduh_pdf
                            ? "fa-spinner fa-spin"
                            : "fa-file-pdf-o",
                        }),
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.mengunduh_pdf ? "Menyiapkan..." : "Export PDF"
                            ) +
                            "\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-outline-secondary",
                    on: {
                      click: function ($event) {
                        _vm.viewer = null
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-arrow-left" }),
                    _vm._v(" Kembali\n                "),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _vm.viewer.loading
              ? _c("div", { staticClass: "text-center py-5" }, [
                  _c("div", {
                    staticClass: "spinner-border text-success",
                    attrs: { role: "status" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-2 fw-semibold text-muted" }, [
                    _vm._v("Memuat isi..."),
                  ]),
                ])
              : _vm.viewer.type === "html"
              ? _c("iframe", {
                  staticClass: "snapshot-frame",
                  attrs: { srcdoc: _vm.viewer.html, frameborder: "0" },
                })
              : _vm.viewer.type === "lab"
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "row g-2 mb-3 small" }, [
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("span", { staticClass: "text-muted" }, [
                          _vm._v("No. Lab"),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", { staticClass: "fw-semibold" }, [
                          _vm._v(_vm._s(_vm.viewer.head.Nolab || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("span", { staticClass: "text-muted" }, [
                          _vm._v("Tanggal Hasil"),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", { staticClass: "fw-semibold" }, [
                          _vm._v(
                            _vm._s(_vm.formatTanggal(_vm.viewer.head.Tglhasil))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("span", { staticClass: "text-muted" }, [
                          _vm._v("Dokter Pengirim"),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", { staticClass: "fw-semibold" }, [
                          _vm._v(_vm._s(_vm.viewer.head.NmDoc || "-")),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.viewer.groups, function (grup, nama_grup) {
                      return _c(
                        "div",
                        { key: nama_grup, staticClass: "mb-3" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "fw-bold text-success border-bottom pb-1 mb-2",
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(nama_grup) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "table-responsive" }, [
                            _c(
                              "table",
                              {
                                staticClass:
                                  "table table-sm table-striped align-middle mb-0",
                              },
                              [
                                _vm._m(0, true),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(grup, function (item, kd_detail) {
                                      return [
                                        _c("tr", { key: `head-${kd_detail}` }, [
                                          _c(
                                            "td",
                                            { staticClass: "fw-semibold" },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(item.head.NMDetail) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              class: {
                                                "text-danger fw-bold":
                                                  _vm.isKritis(item.head),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    item.head.Hasil || "-"
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  item.head.Satuan || "-"
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.nilaiNormal(item.head)
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          item.detail || [],
                                          function (detail) {
                                            return _c(
                                              "tr",
                                              {
                                                key: `detail-${detail.KDDetail}`,
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "ps-4 text-muted",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            — " +
                                                        _vm._s(
                                                          detail.NMDetail
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    class: {
                                                      "text-danger fw-bold":
                                                        _vm.isKritis(detail),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          detail.Hasil || "-"
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(detail.Satuan || "-")
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.nilaiNormal(detail)
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                      ]
                                    }),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    !Object.keys(_vm.viewer.groups).length
                      ? _c("p", { staticClass: "text-muted mb-0" }, [
                          _vm._v(
                            "\n                    Tidak ada detail pemeriksaan pada transaksi ini.\n                "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                )
              : _vm.viewer.type === "cppt"
              ? _c(
                  "div",
                  [
                    _vm.cpptLoading
                      ? _c("div", { staticClass: "text-muted py-3" }, [
                          _c("i", {
                            staticClass: "fa fa-spinner fa-spin me-1",
                          }),
                          _vm._v(
                            " Memuat\n                    CPPT...\n                "
                          ),
                        ])
                      : _vm.cpptError
                      ? _c("p", { staticClass: "text-danger mb-0" }, [
                          _c("i", {
                            staticClass: "fa fa-exclamation-triangle me-1",
                          }),
                          _vm._v(
                            " CPPT\n                    gagal diambil dari api-simrs.\n                "
                          ),
                        ])
                      : _vm.cpptRows.length
                      ? [
                          _c("div", { staticClass: "table-responsive" }, [
                            _c(
                              "table",
                              {
                                staticClass:
                                  "table table-bordered align-middle mb-0 cppt-table",
                              },
                              [
                                _vm._m(1),
                                _vm._v(" "),
                                _vm._l(_vm.cpptRows, function (row) {
                                  return _c(
                                    "tbody",
                                    { key: row.IdCPPT },
                                    _vm._l(
                                      _vm.uraianCppt(row),
                                      function (soap, index) {
                                        return _c(
                                          "tr",
                                          { key: `${row.IdCPPT}-${soap.kode}` },
                                          [
                                            index === 0
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-center",
                                                    attrs: { rowspan: 4 },
                                                  },
                                                  [
                                                    _c("div", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            _vm.formatTanggalCppt(
                                                              row.CreatedAt
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "small text-muted",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              _vm.formatJamCppt(
                                                                row.CreatedAt
                                                              )
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "text-center fw-bold soap-kode",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(soap.kode) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "pre-wrap" },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(soap.isi || "") +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            index === 0
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "pre-wrap align-top small",
                                                    attrs: { rowspan: 4 },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.instruksiCppt(
                                                            row
                                                          ) || ""
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            index === 0
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "align-top small",
                                                    attrs: { rowspan: 4 },
                                                  },
                                                  [
                                                    row.TandaTangan
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mb-1 text-center",
                                                          },
                                                          [
                                                            _c("img", {
                                                              staticStyle: {
                                                                "max-width":
                                                                  "100px",
                                                                "max-height":
                                                                  "50px",
                                                              },
                                                              attrs: {
                                                                src:
                                                                  "/storage/signatures/" +
                                                                  row.TandaTangan,
                                                                alt: "Tanda Tangan",
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "fw-semibold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              row.SavedBy ||
                                                                row.name ||
                                                                "-"
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-muted",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              _vm.formatTanggalCppt(
                                                                row.CreatedAt
                                                              )
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    row.DiisiOleh
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "badge bg-light text-dark border mt-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  row.DiisiOleh
                                                                ) +
                                                                "\n                                        "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    row.ApproveCPPT
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-success small mt-1",
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-check-circle",
                                                            }),
                                                            _vm._v(
                                                              "\n                                            Read back\n                                            " +
                                                                _vm._s(
                                                                  _vm.formatTanggalCppt(
                                                                    row.ApproveCPPTDate
                                                                  )
                                                                ) +
                                                                "\n                                        "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            index === 0
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "align-top small",
                                                    attrs: { rowspan: 4 },
                                                  },
                                                  [
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.unitCppt(row)
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    row.Poli
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-muted",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  row.Poli
                                                                ) +
                                                                "\n                                        "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    row.Regno
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-muted",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                            No. Reg " +
                                                                _vm._s(
                                                                  row.Regno
                                                                ) +
                                                                "\n                                        "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                }),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-wrap align-items-center justify-content-between gap-2 mt-2",
                            },
                            [
                              _c("span", { staticClass: "text-muted small" }, [
                                _vm._v(
                                  "\n                            Halaman " +
                                    _vm._s(_vm.cpptPage) +
                                    " —\n                            " +
                                    _vm._s(_vm.cpptRows.length) +
                                    " dari\n                            " +
                                    _vm._s(_vm.cpptCount) +
                                    " catatan\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "btn-group btn-group-sm" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-secondary",
                                      attrs: { disabled: !_vm.cpptPrev },
                                      on: {
                                        click: function ($event) {
                                          return _vm.pindahHalamanCppt(
                                            _vm.cpptPrev
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-chevron-left",
                                      }),
                                      _vm._v(
                                        "\n                                Sebelumnya\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-secondary",
                                      attrs: { disabled: !_vm.cpptNext },
                                      on: {
                                        click: function ($event) {
                                          return _vm.pindahHalamanCppt(
                                            _vm.cpptNext
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                Berikutnya\n                                "
                                      ),
                                      _c("i", {
                                        staticClass: "fa fa-chevron-right",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      : _c("p", { staticClass: "text-muted mb-0" }, [
                          _c("i", { staticClass: "fa fa-inbox me-1" }),
                          _vm._v(
                            "\n                    Tidak ada CPPT " +
                              _vm._s(_vm.labelCppt) +
                              " untuk pasien ini.\n                "
                          ),
                        ]),
                  ],
                  2
                )
              : _vm.viewer.type === "obat"
              ? _c(
                  "div",
                  [
                    _vm.obatLoading
                      ? _c("div", { staticClass: "text-muted py-3" }, [
                          _c("i", {
                            staticClass: "fa fa-spinner fa-spin me-1",
                          }),
                          _vm._v(
                            " Memuat data\n                    obat...\n                "
                          ),
                        ])
                      : _vm.obatError
                      ? _c("p", { staticClass: "text-danger mb-0" }, [
                          _c("i", {
                            staticClass: "fa fa-exclamation-triangle me-1",
                          }),
                          _vm._v(
                            " Data\n                    obat gagal diambil dari api-simrs.\n                "
                          ),
                        ])
                      : _vm.viewer.jenis === "elektronik"
                      ? [
                          _vm.obatList.length
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row g-3 small mb-3 border-bottom pb-3",
                                    },
                                    _vm._l(_vm.identitasObat, function (item) {
                                      return _c(
                                        "div",
                                        {
                                          key: item.label,
                                          staticClass: "col-md-6 col-lg-4",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.label) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "fw-semibold" },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.value || "-") +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.obatList, function (r) {
                                    return _c(
                                      "div",
                                      { key: r.id, staticClass: "mb-4" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-wrap justify-content-between gap-2 mb-2",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "badge bg-success",
                                              },
                                              [_vm._v("Resep " + _vm._s(r.id))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "text-muted small",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(r.dokter || "-") +
                                                    " —\n                                    " +
                                                    _vm._s(
                                                      _vm.formatTanggalJamObat(
                                                        r.jam || r.tanggal
                                                      )
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "border rounded p-3 bg-white",
                                          },
                                          [
                                            _vm._l(
                                              r.non_racikan,
                                              function (obat) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: obat.kode_obat,
                                                    staticClass: "resep-baris",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "resep-r",
                                                      },
                                                      [_vm._v("R/")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fw-semibold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                obat.nama_obat
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-muted small",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            S\n                                            " +
                                                              _vm._s(
                                                                obat.signa_manual ||
                                                                  obat.signa
                                                              ) +
                                                              "\n                                            "
                                                          ),
                                                          obat.jumlah_hari
                                                            ? [
                                                                _vm._v(
                                                                  "\n                                                —\n                                                " +
                                                                    _vm._s(
                                                                      obat.jumlah_hari
                                                                    ) +
                                                                    " hari\n                                            "
                                                                ),
                                                              ]
                                                            : _vm._e(),
                                                        ],
                                                        2
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-nowrap",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                        No. " +
                                                            _vm._s(obat.qty) +
                                                            "\n                                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              r.racikan_dokter,
                                              function (rd) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: `rd-${rd.no_racikan}`,
                                                    staticClass: "resep-baris",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "resep-r",
                                                      },
                                                      [_vm._v("R/")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fw-semibold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            Racikan ke-" +
                                                              _vm._s(
                                                                rd.no_racikan
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-muted small",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            S " +
                                                              _vm._s(
                                                                rd.signa1
                                                              ) +
                                                              " dd\n                                            " +
                                                              _vm._s(
                                                                rd.signa2
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "ul",
                                                        {
                                                          staticClass:
                                                            "mb-0 ps-3 small",
                                                        },
                                                        _vm._l(
                                                          rd.obat,
                                                          function (obat) {
                                                            return _c(
                                                              "li",
                                                              {
                                                                key: obat.kode_obat,
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      obat.nama_obat
                                                                    ) +
                                                                    "\n                                            "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-nowrap",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                        No. " +
                                                            _vm._s(rd.qty) +
                                                            "\n                                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              r.racikan,
                                              function (rc, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: `rc-${index}`,
                                                    staticClass: "resep-baris",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "resep-r",
                                                      },
                                                      [_vm._v("R/")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fw-semibold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                rc.Racikan
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-muted small",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            S " +
                                                              _vm._s(
                                                                rc.Signa || "-"
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-nowrap",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                        No. " +
                                                            _vm._s(rc.Catatan) +
                                                            "\n                                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              )
                            : _c("p", { staticClass: "text-muted mb-0" }, [
                                _c("i", { staticClass: "fa fa-inbox me-1" }),
                                _vm._v(
                                  " Belum ada resep\n                        elektronik pada registrasi ini.\n                    "
                                ),
                              ]),
                        ]
                      : _vm.obatList.length
                      ? _vm._l(_vm.obatList, function (r) {
                          return _c(
                            "div",
                            { key: r.id, staticClass: "card border mb-3" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "card-header bg-light d-flex flex-wrap align-items-center gap-2 py-2",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "badge bg-success" },
                                    [_vm._v("Resep ke-" + _vm._s(r.resep_ke))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "fw-semibold small" },
                                    [_vm._v(_vm._s(_vm.waktuResep(r)))]
                                  ),
                                  _vm._v(" "),
                                  r.poli
                                    ? _c(
                                        "span",
                                        { staticClass: "text-muted small" },
                                        [_vm._v(_vm._s(r.poli))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "text-muted small ms-auto" },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(r.dokter || "-") +
                                          "\n                                "
                                      ),
                                      r.regno
                                        ? [
                                            _vm._v(
                                              "— No. Reg " + _vm._s(r.regno)
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "table-responsive" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-sm align-middle mb-0",
                                  },
                                  [
                                    _vm._m(2, true),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      _vm._l(r.obat, function (obat) {
                                        return _c(
                                          "tr",
                                          {
                                            key: `${r.id}-${obat.kode_obat}-${obat.no_racikan}`,
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(obat.kode_obat) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(obat.nama_obat) +
                                                  "\n                                            "
                                              ),
                                              obat.jenis === 4
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "badge bg-secondary ms-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                Racikan ke-" +
                                                          _vm._s(
                                                            obat.no_racikan
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(obat.qty) +
                                                  " " +
                                                  _vm._s(obat.satuan) +
                                                  "\n                                        "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    obat.signa_manual ||
                                                      obat.signa
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "small text-muted",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      obat.keterangan_pakai ||
                                                        obat.cara_minum ||
                                                        ""
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              (r.racikan || []).length
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "table-responsive border-top",
                                    },
                                    [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-sm align-middle mb-0",
                                        },
                                        [
                                          _vm._m(3, true),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              r.racikan,
                                              function (rc, index) {
                                                return _c(
                                                  "tr",
                                                  {
                                                    key: `${r.id}-rc-${index}`,
                                                  },
                                                  [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(rc.Racikan)
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(_vm._s(rc.Signa)),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(rc.Catatan)
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        })
                      : _c("p", { staticClass: "text-muted mb-0" }, [
                          _c("i", { staticClass: "fa fa-inbox me-1" }),
                          _vm._v(
                            " Tidak ada\n                    " +
                              _vm._s(_vm.labelObat) +
                              " untuk pasien ini.\n                "
                          ),
                        ]),
                  ],
                  2
                )
              : _vm.viewer.type === "rad"
              ? _c(
                  "div",
                  [
                    _vm._l(_vm.viewer.rows, function (row, index) {
                      return _c("div", { key: index, staticClass: "mb-4" }, [
                        _c("div", { staticClass: "row g-2 mb-2 small" }, [
                          _c("div", { staticClass: "col-md-4" }, [
                            _c("span", { staticClass: "text-muted" }, [
                              _vm._v("Pemeriksaan"),
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "fw-semibold" }, [
                              _vm._v(_vm._s(row.NmTarif || "-")),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c("span", { staticClass: "text-muted" }, [
                              _vm._v("Tanggal Hasil"),
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "fw-semibold" }, [
                              _vm._v(_vm._s(_vm.formatTanggal(row.TglHasil))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c("span", { staticClass: "text-muted" }, [
                              _vm._v("Dokter Pembaca"),
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "fw-semibold" }, [
                              _vm._v(_vm._s(row.DokterPembaca || "-")),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "border rounded p-3 bg-white hasil-rad",
                          domProps: { innerHTML: _vm._s(row.Hasil) },
                        }),
                        _vm._v(" "),
                        index === 0 && row.photo_url && row.photo_url.photo_url
                          ? _c(
                              "div",
                              { staticClass: "mt-2 d-flex flex-wrap gap-2" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-primary",
                                    attrs: {
                                      href: row.photo_url.photo_url,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-eye" }),
                                    _vm._v(
                                      " Lihat Citra\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                row.photo_url.photo_url_vol_render
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-sm btn-outline-primary",
                                        attrs: {
                                          href: row.photo_url
                                            .photo_url_vol_render,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c("i", { staticClass: "fa fa-cube" }),
                                        _vm._v(
                                          " Volume Render\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (row.foto || []).length
                          ? _c(
                              "div",
                              { staticClass: "mt-2 d-flex flex-wrap gap-2" },
                              _vm._l(row.foto, function (foto) {
                                return _c(
                                  "figure",
                                  {
                                    key: foto.HasilRadiologiFotoId,
                                    staticClass: "mb-0 text-center",
                                  },
                                  [
                                    _vm.fotoSrc(foto)
                                      ? _c("img", {
                                          staticClass: "img-thumbnail rad-foto",
                                          attrs: {
                                            src: _vm.fotoSrc(foto),
                                            alt:
                                              foto.Keterangan ||
                                              "Foto radiologi",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "figcaption",
                                      { staticClass: "small text-muted" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(foto.Keterangan || "-") +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ])
                    }),
                    _vm._v(" "),
                    !_vm.viewer.rows.length
                      ? _c("p", { staticClass: "text-muted mb-0" }, [
                          _vm._v(
                            "\n                    Hasil radiologi tidak ditemukan.\n                "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ])
      : _c(
          "div",
          { staticClass: "accordion", attrs: { id: "accordion-riwayat-icd" } },
          _vm._l(_vm.sections, function (section) {
            return _c(
              "div",
              { key: section.key, staticClass: "accordion-item" },
              [
                _c("h2", { staticClass: "accordion-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "accordion-button collapsed",
                      attrs: {
                        type: "button",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": `#collapse-icd-${section.key}`,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.loadSection(section.key)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa me-2 text-success",
                        class: section.icon,
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(section.title) +
                          "\n                    "
                      ),
                      _vm.counts[section.key] !== null
                        ? _c(
                            "span",
                            { staticClass: "badge bg-secondary ms-2" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.counts[section.key]) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "accordion-collapse collapse",
                    attrs: {
                      id: `collapse-icd-${section.key}`,
                      "data-bs-parent": "#accordion-riwayat-icd",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "accordion-body" },
                      [
                        _vm.menu[section.kind]
                          ? _c(
                              "ul",
                              { staticClass: "list-unstyled mb-0" },
                              _vm._l(_vm.menu[section.kind], function (jenis) {
                                return _c(
                                  "li",
                                  {
                                    key: jenis.value,
                                    staticClass: "py-1 border-bottom",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.openMenu(section, jenis)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa me-1",
                                          class: jenis.icon,
                                        }),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(jenis.label) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm.loading[section.key]
                          ? _c("div", { staticClass: "text-muted" }, [
                              _c("i", {
                                staticClass: "fa fa-spinner fa-spin me-1",
                              }),
                              _vm._v(
                                " Memuat\n                        data...\n                    "
                              ),
                            ])
                          : _vm.errors[section.key]
                          ? _c("p", { staticClass: "text-danger mb-0" }, [
                              _c("i", {
                                staticClass: "fa fa-exclamation-triangle me-1",
                              }),
                              _vm._v(
                                "\n                        Data gagal diambil dari api-simrs.\n                    "
                              ),
                            ])
                          : (_vm.items[section.key] || []).length
                          ? [
                              section.kind === "form"
                                ? _c(
                                    "ul",
                                    { staticClass: "list-unstyled mb-0" },
                                    _vm._l(
                                      _vm.items[section.key],
                                      function (row) {
                                        return _c(
                                          "li",
                                          {
                                            key: `${row.form_id}-${row.id}`,
                                            staticClass: "py-1 border-bottom",
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.openForm(row)
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-file-text-o me-1",
                                                }),
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(row.head_name) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-muted small ms-2",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.formatTanggalJam(
                                                        row.created_at
                                                      )
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : section.kind === "lab"
                                ? _c(
                                    "ul",
                                    { staticClass: "list-unstyled mb-0" },
                                    _vm._l(
                                      _vm.items[section.key],
                                      function (row) {
                                        return _c(
                                          "li",
                                          {
                                            key: row.Notran,
                                            staticClass: "py-1 border-bottom",
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.openLab(row)
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-flask me-1",
                                                }),
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(row.date) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : section.kind === "rad"
                                ? _c(
                                    "ul",
                                    { staticClass: "list-unstyled mb-0" },
                                    _vm._l(
                                      _vm.items[section.key],
                                      function (row, index) {
                                        return _c(
                                          "li",
                                          {
                                            key: `${row.NoTran}-${index}`,
                                            staticClass: "py-1 border-bottom",
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.openRad(row)
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-photo me-1",
                                                }),
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(row.date) +
                                                    " —\n                                    " +
                                                    _vm._s(row.NmTarif || "-") +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : section.kind === "dokumen"
                                ? _c(
                                    "ul",
                                    { staticClass: "list-unstyled mb-0" },
                                    _vm._l(
                                      _vm.items[section.key],
                                      function (row, index) {
                                        return _c(
                                          "li",
                                          {
                                            key: index,
                                            staticClass:
                                              "py-1 border-bottom d-flex justify-content-between gap-2",
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: _vm.dokumenUrl(
                                                    row.Fileurl
                                                  ),
                                                  target: "_blank",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-paperclip me-1",
                                                }),
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(row.Filename) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "text-muted small",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.formatTanggal(
                                                        row.Uploaddate
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                ),
                                                row.UploadBy
                                                  ? [
                                                      _vm._v(
                                                        "— " +
                                                          _vm._s(row.UploadBy)
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c(
                                    "div",
                                    _vm._l(
                                      _vm.items[section.key],
                                      function (berkas) {
                                        return _c(
                                          "div",
                                          {
                                            key: berkas.id,
                                            staticClass:
                                              "mb-3 pb-3 border-bottom",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-wrap align-items-baseline gap-2 mb-2",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge bg-success",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          berkas.doc_title ||
                                                            "-"
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "fw-semibold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          berkas.doc_description ||
                                                            "-"
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-muted small ms-auto",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.formatTanggal(
                                                            berkas.created_at
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                    berkas.created_by
                                                      ? [
                                                          _vm._v(
                                                            "\n                                            — " +
                                                              _vm._s(
                                                                berkas.created_by
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-wrap gap-2",
                                              },
                                              _vm._l(
                                                _vm.fileBerkas(berkas),
                                                function (file, index) {
                                                  return _c(
                                                    "button",
                                                    {
                                                      key: file.key,
                                                      staticClass:
                                                        "btn btn-light border p-1 berkas-thumb",
                                                      attrs: {
                                                        type: "button",
                                                        title: `Klik untuk memperbesar — ${file.label}`,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openBerkas(
                                                            berkas,
                                                            index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: file.url,
                                                          alt: file.label,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-block small text-muted mt-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                file.label
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _vm._v(" "),
                                            !_vm.fileBerkas(berkas).length
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-muted small mb-0",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    Tidak ada file pada berkas ini.\n                                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                            ]
                          : _c("p", { staticClass: "text-muted mb-0" }, [
                              _c("i", { staticClass: "fa fa-inbox me-1" }),
                              _vm._v(
                                " Tidak ada data yang\n                        ditampilkan.\n                    "
                              ),
                            ]),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
    _vm._v(" "),
    _vm.preview
      ? _c(
          "div",
          {
            staticClass: "berkas-preview",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.closeBerkas.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "berkas-preview-bar" }, [
              _c("span", { staticClass: "text-truncate" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.preview.title) +
                    "\n                "
                ),
                _c("span", { staticClass: "opacity-75" }, [
                  _vm._v(
                    "\n                    — " +
                      _vm._s(_vm.preview.index + 1) +
                      " / " +
                      _vm._s(_vm.preview.files.length) +
                      "\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex gap-2" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-sm btn-outline-light",
                    attrs: {
                      href: _vm.preview.files[_vm.preview.index].url,
                      target: "_blank",
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-external-link" }),
                    _vm._v(" Buka Tab Baru\n                "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-outline-light",
                    on: { click: _vm.closeBerkas },
                  },
                  [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v(" Tutup\n                "),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.preview.files.length > 1
              ? _c(
                  "button",
                  {
                    staticClass: "berkas-nav start-0",
                    attrs: { "aria-label": "Sebelumnya" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.geserBerkas(-1)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-chevron-left" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("img", {
              staticClass: "berkas-preview-img",
              attrs: {
                src: _vm.preview.files[_vm.preview.index].url,
                alt: _vm.preview.files[_vm.preview.index].label,
              },
            }),
            _vm._v(" "),
            _vm.preview.files.length > 1
              ? _c(
                  "button",
                  {
                    staticClass: "berkas-nav end-0",
                    attrs: { "aria-label": "Berikutnya" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.geserBerkas(1)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-chevron-right" })]
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light" }, [
      _c("tr", [
        _c("th", [_vm._v("Pemeriksaan")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "140px" } }, [_vm._v("Hasil")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "100px" } }, [_vm._v("Satuan")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "180px" } }, [
          _vm._v(
            "\n                                        Nilai Normal\n                                    "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light text-center" }, [
      _c("tr", [
        _c("th", { staticStyle: { width: "130px" } }, [
          _vm._v(
            "\n                                        Tanggal dan Jam Pemeriksaan\n                                    "
          ),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { colspan: "2" } }, [_vm._v("Uraian Pemeriksaan")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "200px" } }, [
          _vm._v(
            "\n                                        Instruksi DPJP\n                                    "
          ),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "170px" } }, [
          _vm._v(
            "\n                                        Nama & Tanda Tangan DPJP /\n                                        Tenaga Kesehatan\n                                    "
          ),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "110px" } }, [_vm._v("Unit")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light" }, [
      _c("tr", [
        _c("th", { staticStyle: { width: "110px" } }, [_vm._v("Kode")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nama Obat")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "80px" } }, [_vm._v("Qty")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "170px" } }, [_vm._v("Signa")]),
        _vm._v(" "),
        _c("th", [_vm._v("Keterangan")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light" }, [
      _c("tr", [
        _c("th", [_vm._v("Racikan")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "170px" } }, [_vm._v("Signa")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "80px" } }, [_vm._v("Qty")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }